module.exports = __webpack_public_path__ + "img/6.3ab111b5.png";